module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mv-f252e4cb6189ffbeb1ed63db451356ad.svg";